module.exports = __webpack_public_path__ + "static/img/irole.5179aad.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/xk/irole.png
// module id = HGLi
// module chunks = 7